import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

const SEO = ({ title, description, type = "website", name, image, url, themeColor }) => {
  const siteName = "9tro Ride";
  const location = useLocation();

  // Determine active theme color based on route if not explicitly passed
  const isEatsRoute =
    location.pathname.startsWith("/9troeat") ||
    location.pathname.startsWith("/food") ||
    location.pathname.startsWith("/restaurant") ||
    location.pathname.startsWith("/chef") ||
    location.pathname.startsWith("/store");

  const activeThemeColor = themeColor || (isEatsRoute ? "#E3242B" : "#8EDC06");

  useEffect(() => {
    // Dynamically update DOM meta theme-color tag for mobile status bars
    const metaThemeColor = document.querySelector('meta[name="theme-color"]');
    if (metaThemeColor) {
      metaThemeColor.setAttribute("content", activeThemeColor);
    }
  }, [activeThemeColor]);

  return (
    <Helmet>
      {/* Dynamic Theme Color */}
      <meta name="theme-color" content={activeThemeColor} />
      <meta name="msapplication-TileColor" content={activeThemeColor} />

      {/* Standard metadata tags */}
      <title>{title ? `${title} | ${siteName}` : siteName}</title>
      <meta name='description' content={description} />

      {/* OpenGraph tags for Facebook, LinkedIn, etc. */}
      <meta property='og:type' content={type} />
      <meta
        property='og:title'
        content={title ? `${title} | ${siteName}` : siteName}
      />
      <meta property='og:description' content={description} />
      {image && <meta property='og:image' content={image} />}
      {url && <meta property='og:url' content={url} />}
      <meta property='og:site_name' content={siteName} />

      {/* Twitter tags */}
      <meta name='twitter:creator' content={name} />
      <meta
        name='twitter:card'
        content={image ? "summary_large_image" : "summary"}
      />
      <meta
        name='twitter:title'
        content={title ? `${title} | ${siteName}` : siteName}
      />
      <meta name='twitter:description' content={description} />
      {image && <meta name='twitter:image' content={image} />}
    </Helmet>
  );
};

export default SEO;
